export class ContentEdit {
    parent;
    constructor(parent) {
        this.parent = parent;
    }
    get content() {
        return this.parent;
    }
    get trait() {
        return this.content.trait;
    }
}
